import { render, staticRenderFns } from "./templateDetail.vue?vue&type=template&id=d9b3e2a2&scoped=true"
import script from "./templateDetail.vue?vue&type=script&lang=js"
export * from "./templateDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b3e2a2",
  null
  
)

export default component.exports